@if (column.sortable) {
  <div
    (click)="sortFunc()"
    class="custom-sort">
    {{ column.name }}
    @if (!sortDir) {
      <span class="sort-btn datatable-icon-sort-unset"></span>
    }
    @if (sortDir === "asc") {
      <span class="sort-btn datatable-icon-up sort-asc"></span>
    }
    @if (sortDir === "desc") {
      <span class="sort-btn datatable-icon-down sort-desc"></span>
    }
  </div>
} @else {
  {{ column.name }}
}
